import { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
    EligibleModelData,
    useDyfEligibleModel,
} from '../use-dyf-eligible-model/use-dyf-eligible-model';

import ServerContext from '../../../contexts/serverContext';
import { SinglePublicFeature } from '../use-your-vehicle-features/vehicle-features.types';
import { getPublicCategories } from '../use-your-vehicle-features/category-utils';

export const useAuthenticatedArticles = (): {
    loading: boolean;
    publicCategories: SinglePublicFeature[];
    dyfEligibleModel: EligibleModelData | null;
} => {
    const { vin = '', year = '', model = '' } = useParams<{
        vin?: string;
        year?: string;
        model?: string;
    }>();

    const eligibleQuery = useMemo(
        () => (vin !== '' ? { vin } : { modelAlias: model, year }),
        []
    );
    const {
        data: dyfEligibleModel,
        loading: dyfEligibleLoading,
    } = useDyfEligibleModel(eligibleQuery);

    const { currentLanguageRegionCode } = useContext(ServerContext);

    const [loading, setLoading] = useState(true);
    const [publicCategories, setPublicCategories] = useState<
        SinglePublicFeature[]
    >([]);

    useEffect(() => {
        if (!dyfEligibleLoading && dyfEligibleModel) {
            setLoading(false);
            setPublicCategories(
                getPublicCategories(
                    dyfEligibleModel.vehicleType,
                    currentLanguageRegionCode
                )
            );
        }
    }, [dyfEligibleLoading]);

    return {
        loading,
        publicCategories,
        dyfEligibleModel,
    };
};
